/* eslint-disable filenames/match-exported */
import IS_CLIENT_RENDERED from "../util/isClientRendered";
import { MIXPANEL_TOKEN } from "../util/constants";

let mixpanel;
if (IS_CLIENT_RENDERED) {
  mixpanel = require("mixpanel-browser");
  mixpanel.init(MIXPANEL_TOKEN, { autotrack: false });
} else {
  mixpanel = {
    init: () => null,
    track: () => null,
    identify: () => null,
    time_event: () => null,
    people: {
      set: () => null,
      set_once: () => null,
      increment: () => null,
    },
  };
}

export const incrementPostViewsMP = count => mixpanel.people.increment("Seen posts", count);

export const trackRecommendedCaseClick = ({
  currentPost: { _id: currentPostId, title: currentPostTitle },
  recommendedPost: { _id: recommendedPostId, title: recommendedPostTitle, index: recommendedPostIndex },
}) => {
  mixpanel.track("similar post click", {
    currentPostId,
    currentPostTitle,
    recommendedPostId,
    recommendedPostTitle,
    recommendedPostIndex: recommendedPostIndex + 1,
  });
};

export default mixpanel;



// WEBPACK FOOTER //
// ./src/services/mixpanel.js